import { render } from "./aceppt-term-use.vue?vue&type=template&id=2ff85cc2"
import script from "./aceppt-term-use.vue?vue&type=script&lang=js"
export * from "./aceppt-term-use.vue?vue&type=script&lang=js"

import "./aceppt-term-use.vue?vue&type=style&index=0&id=2ff85cc2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__